<div class="form-group">
  <label class="control-label col-xs-4">
    {{field.schema.description}}
    <span class="text-danger" ng-if="field.schema.required">*</span>
  </label>

  <div class="col-xs-8">
    <!-- Select -->
    <ui-select ng-model="field.value" theme="bootstrap" ng-if="field.schema.type === 'select'" ng-change="field.schema.function($select.selected)" ng-required="field.schema.required">
      <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="item in field.schema.items | filter: $select.search">
        <span ng-bind-html="item.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>

    <!-- Multi select -->
    <ui-select ng-model="field.value" theme="bootstrap" ng-if="field.schema.type === 'multiselect'" ng-change="field.schema.function($select.selected)" ng-required="field.schema.required" multiple>
      <ui-select-match allow-clear="true" placeholder="">{{$item.descricao}}</ui-select-match>
      <ui-select-choices repeat="item in field.schema.items | filter: $select.search">
        <span ng-bind-html="item.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>

    <!-- String -->
    <input type="text" ng-if="field.schema.type === 'string'" ng-required="field.schema.required" ng-model="field.value" class="form-control">

    <!-- Number -->
    <input type="number" ng-if="field.schema.type === 'number'" ng-required="field.schema.required" ng-model="field.value" class="form-control">

    <!-- Checkbox -->
    <div class="checkbox" ng-if="field.schema.type === 'checkbox'">
      <label>
        <input type="checkbox" ng-required="field.schema.required" ng-model="field.value">
      </label>
    </div>

    <!-- Date -->
    <p class="input-group" ng-if="field.schema.type === 'date'">
      <input type="text"
          readonly
          datepicker-options="field.datePickerOptionsGeral"
          uib-datepicker-popup="dd/MM/yyyy"
          ng-model="field.value"
          class="form-control"
          is-open="popup2.opened"
          ng-required="field.schema.required"
          ng-click="popup2.opened = !popup2.opened">
      <span class="input-group-btn">
        <button type="button" class="btn btn-default"
                ng-click="popup2.opened = !popup2.opened">
          <i class="glyphicon glyphicon-calendar"></i>
        </button>
      </span>
    </p>
  </div>
</div>
